import { useEffect, useState } from 'react';
import CameraStreamWidget from './CameraStreamWidget.jsx';

const CAMERAS = [1, 2, 3, 4, 5, 6];

// background=false makes go2rtc's player drop the connection when the tab is
// hidden (e.g. switching apps), instead of streaming on in the background --
// worth having with everyone sharing one office link.
const WALL_URL =
  'https://cams.ascoat.com.au/stream.html?' +
  CAMERAS.map((n) => `src=camera${n}`).join('&') +
  '&background=false';

const singleUrl = (n) => `https://cams.ascoat.com.au/webrtc.html?src=camera${n}&media=video+audio`;

// Matches Tailwind's `md` breakpoint, which the rest of the page already uses
// to tell "phone" from "desktop".
const DESKTOP_QUERY = '(min-width: 768px)';

function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(DESKTOP_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_QUERY);
    const onChange = () => setIsDesktop(mq.matches);
    mq.addEventListener('change', onChange);
    onChange();
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isDesktop;
}

// Desktop: all six cameras as one wall (go2rtc's stream.html lays them out in
// a wrapping grid). Phones: one camera at a time with a picker, because the
// wall's feeds are laid out ~320px each -- on a phone that's one visible and
// five clipped -- and clipped feeds keep connecting and decoding regardless,
// which is a lot of work for a phone to show a single picture.
//
// Either way nothing connects until someone presses Load.
export default function CamerasWidget() {
  const isDesktop = useIsDesktop();
  const [cam, setCam] = useState(1);

  if (isDesktop) {
    return <CameraStreamWidget url={WALL_URL} label="All cameras" wide />;
  }

  return (
    <CameraStreamWidget url={singleUrl(cam)} label={`Camera ${cam}`}>
      <div className="mb-3 flex w-fit gap-1 rounded-lg bg-steel/10 p-0.5" role="group" aria-label="Choose a camera">
        {CAMERAS.map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => setCam(n)}
            aria-pressed={cam === n}
            className={`rounded-md px-3 py-1.5 text-xs font-medium transition ${
              cam === n ? 'bg-navy text-white' : 'text-steel hover:bg-steel/10'
            }`}
          >
            {n}
          </button>
        ))}
      </div>
    </CameraStreamWidget>
  );
}
